<template>
  <div>
    <Modal v-model="visible" :mask-closable="false" :title="title" width="1010px" class="my-modal">
      <loading :isShow="loading" />
      <Form ref="myForm" :model="formData" class="page-form less" :label-width="120" :class="{'first': formData.imgType == '1'}" >
        <FormItem label="栏目" prop="parentId" :rules="$units.formRule.required('请选择')" class="full">
          <Select v-model="formData.parentId" filterable @on-change="parentIdChange">
            <Option v-for="item in typeList" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="产品名称" prop="productCode" :rules="$units.formRule.required('请选择')">
          <span style="margin-right: 10px" v-if="formData.productCode">{{ formData.productName }}</span>
          <Button type="primary" @click="$refs.selProductList.open()">{{ formData.productCode ? '更换产品' : '选择产品' }}</Button>
        </FormItem>
        <br>
        <FormItem label="产品编码" class="less">
          {{ formData.productCode }}
        </FormItem>
        <FormItem label="产品分类" class="less">
          {{ formData.themeName }}
        </FormItem>
        <FormItem label="图片类型" prop="imgType"  :rules="$units.formRule.required('请选择')" class="full" v-if="curTab.name == '平台热卖'">
          <RadioGroup v-model="formData.imgType" @on-change="imgTypeChange">
            <Radio label="1">首图</Radio>
            <Radio label="2">常规图</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="图片" prop="img" :rules="$units.formRule.required('请选择')" class="img-item">
          <div class="img-box" v-if="formData.img">
            <img :src="formData.img" class="img" />
            <div class="img-info-box">
              <div class="img-title">{{formData.title}}</div>
              <div class="img-text">{{formData.profile}}</div>
              <div class="img-fee" v-if="formData.isShowCommission == 1">
                <p class="text1">{{$units.isOkBao() ? '推广费最高' : '服务费最高'}}</p>
                <p class="text2">XX.XX%</p>
              </div>
            </div>
            <Button type="primary" ghost @click="$refs.selImgList.open()">选择底图</Button>
            <Button type="primary" ghost @click="$refs.selImgList.randomImg(formData.img)">随机生成</Button>
          </div>
        </FormItem>
        <FormItem label="产品标题" prop="title" :rules="$units.formRule.required('请选择')" class="less">
          <Input v-model="formData.title" type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入"/>
        </FormItem>
        <FormItem label="产品特色" prop="profile" :rules="$units.formRule.required('请选择')" class="less">
          <Input v-model="formData.profile" type="textarea" :autosize="{ minRows: 3 }" placeholder="请输入"/>
        </FormItem>
        <FormItem label="展示费用" class="less">
          <RadioGroup v-model="formData.isShowCommission">
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="排序" prop="sort" :rules="$units.formRule.required('请选择')">
          <Select v-model="formData.sort" :disabled="formData.imgType == 1">
            <Option value="1" v-show="formData.imgType == 1 || curTab.name != '平台热卖'">1</Option>
            <Option value="2">2</Option>
            <Option value="3">3</Option>
            <Option value="4">4</Option>
            <Option value="5">5</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" ghost @click="visible = false">取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Modal>
    <!-- 选择底图 -->
    <sel-img-list ref="selImgList" @select="selectImg" :imgType="formData.imgType" />
    <!-- 选择产品 -->
    <sel-product-list ref="selProductList" @select="selectProduct" />
  </div>
</template>
<script>
import selProductList from './selProductList';
import selImgList from './selImgList';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {
    selImgList,
    selProductList
  },
  props: {
    parentId: null,
    typeList: null
  },
  data: () => ({
    title: '',
    visible: false,
    loading: false,
    formData: {
      sort:''
    }
  }),
  computed: {
    curTab() {
      if (!this.typeList || this.typeList.length == 0) {
        return {};
      }
      const data = this.typeList.find(item => item.id == this.formData.parentId);
      if (data) {
        return data;
      } else {
        return {};
      }
    }
  },
  created() {},
  methods: {
    // 选择栏目
    parentIdChange() {
      if (this.curTab.name == '平台热卖') {
        // 切换到平台热卖且非首图且排序是1时重置排序为2
        if (this.formData.imgType != 1 && this.formData.sort == 1) {
          this.$set(this.formData, 'sort', '2');
        }
      } else {
        this.formData.imgType = '2';
      }
    },
    // 切换图片类型
    imgTypeChange() {
      this.$set(this.formData, 'img', '');
      if (this.formData.imgType == 1) {
        this.$set(this.formData, 'sort', '1');
      } else {
        this.$set(this.formData, 'sort', '');
      }
      this.$nextTick(()=>{
        this.$refs.selImgList.randomImg();
      })
    },
    // 选择底图回调
    selectImg(url) {
      this.$set(this.formData, 'img', url);
    },
    // 选择产品回调
    selectProduct(data) {
      this.$set(this.formData, 'productCode', data.productCode);
      this.$set(this.formData, 'productName', data.productName);
      this.$set(this.formData, 'title', data.productName);
      this.$set(this.formData, 'profile', data.feature);
      this.$set(this.formData, 'productId', data.id);
      this.$set(this.formData, 'themeName', data.themeName);
    },
    open(data) {
      if (data.id) {
        this.title = '编辑';
        this.getDetail(data.id);
      } else {
        this.title = '新增';
        this.formData = {
          imgType: '2',
          isShowCommission: '0',
          sort: '',
          parentId: this.parentId
        };
        this.$nextTick(() => {
          this.$refs.selImgList.randomImg();
        });
      }
      this.clearValidate();
      this.visible = true;
    },
    submit() {
      this.$refs.myForm.validate(valid => {
        if (valid) {
          if(this.loading) {
            return;
          }
          this.loading = true;
          this.$http({
            url: '/buz/exhibitionPicConfig/addSellCard',
            type: 'POST',
            data: this.formData
          }).then(res => {
            this.visible = false;
            this.$emit('reload');
            this.$notice.success('提交成功');
          }).finally(()=>{
            window.setTimeout(()=>{
              this.loading = false;
            }, 200);
          });
        }
      });
    },
    // 获取详情数据
    getDetail(id) {
      this.$http({
        url: '/buz/exhibitionPicConfig/sellCard/detail',
        type: 'GET',
        data: {
          id
        }
      }).then(res => {
        res.data.sort = res.data.sort ? res.data.sort + '' : '';
        this.formData = res.data;
      });
    },
  }
};
</script>
<style lang='scss' scoped>
@import './editModal.scss';
</style>